import {css} from 'lit'; export default css`sds-fieldset+sds-fieldset{border-top:1px solid #ececf7;padding-top:24px;margin-top:24px}`;
    